import type { DriverTaskKpiRow } from '@klareospace/pharos-lib-types';
import { isDriverTaskKpiRows, KPI_KEYS } from '@klareospace/pharos-lib-types';

import { useKpiMtdQuery } from './use-kpi-mtd-query';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface UseDriverKpisMonthParams {
  /** The "This month" tab must be active for this query to run — no request fires on page load. */
  enabled: boolean;
}

export interface UseDriverKpisMonthResult {
  isError: boolean;
  isLoading: boolean;
  rows: DriverTaskKpiRow[] | undefined;
}

// ─── Hook ─────────────────────────────────────────────────────────────────────

/** Fetches the month-to-date `driver-task-kpis` KPI for the current scope, gated on `kpis:read` + `enabled`. `rows` is absent while still computing. */
export function useDriverKpisMonth({ enabled }: UseDriverKpisMonthParams): UseDriverKpisMonthResult {
  const { data, isError, isLoading } = useKpiMtdQuery({
    enabled,
    fetchKpi: (api, params) => api.getDriverKpisMtd(params),
    key: KPI_KEYS.DRIVER_TASK_KPIS,
  });

  return {
    isError,
    isLoading,
    rows: isDriverTaskKpiRows(data?.metrics) ? data.metrics : undefined,
  };
}
